export default __webpack_public_path__ + "static/media/microsoft.efefd106.svg";